import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { partnerConnect } from 'src/app/core/models/connect.models';
import { LeadService } from 'src/app/core/services/lead/lead.service';

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.scss']
})
export class PartnerComponent implements OnInit {

  public partnerForm: FormGroup;
  constructor(private titleService: Title, 
    private toastr: ToastrService,
    private leadService: LeadService,
    private metaService: Meta ) { 

    this.partnerForm = new FormGroup({
      email: new FormControl(null, Validators.required),
      name: new FormControl(null, Validators.required),
      expertise: new FormControl(null, Validators.required),
      city: new FormControl(null, Validators.required),
      telephone: new FormControl(null, Validators.required),
      website: new FormControl(null, Validators.required)
    });
  }

  ngOnInit() {
    this.setSEOData();
  }

  async partner()
  {
    const {email, name, telephone, city, expertise, website} = this.partnerForm.value;
    if(email == "" || email == undefined || email == null)
    {
      this.toastr.error("Email cannot be empty", "Partner Us");
    }
    else  if(name == "" || name == undefined || name == null)
    {
      this.toastr.error("Name cannot be empty", "Partner Us");
    }
    else  if(telephone == "" || telephone == undefined || telephone == null)
    {
      this.toastr.error("Mobile Number cannot be empty", "Partner Us");
    }
    else  if(city == "" || city == undefined || city == null)
    {
      this.toastr.error("City cannot be empty", "Partner Us");
    }
    else{
      this.toastr.info("Please wait as your request is in progress", "Partner Us");
      let contactRequest : partnerConnect = {
       
        website: website,
        city: city,
        expertise: expertise,
        phone: telephone,
        email: email,
        name: name
      }
      await this.leadService.partnerContact(contactRequest);
      this.toastr.success("Thanks for reaching us, someone from our team will contact you soon", "Partner Us");
    }
  }

  setSEOData(): void {
   

    let aboutDescription = `Be a Partner of EWNS, Custom Ecommerce platform to meet all your digital needs, Enable social commerce and Ecommerce in matter of minutes, Create and manage website from anywhere on any device, Enable digital commerce for your business`;

    this.titleService.setTitle(aboutDescription);

    this.metaService.addTag({name: 'name', content: aboutDescription});
    this.metaService.addTag({name: 'description', content: aboutDescription});
    this.metaService.addTag({name: 'image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
    this.metaService.addTag({name: 'logo', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
    this.metaService.addTag({name: 'keywords', content: aboutDescription})


    this.metaService.addTag({name: 'twitter:card', content: 'product'});
    this.metaService.addTag({name: 'twitter:title', content: aboutDescription});
    this.metaService.addTag({name: 'twitter:description', content: aboutDescription});
    this.metaService.addTag({name: 'twitter:image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})


    //OG GRAPH DATA
    this.metaService.addTag({name: 'og:type', content: 'article'});
    this.metaService.addTag({name: 'og:site_name', content: 'EWNS'});
    this.metaService.addTag({name: 'og:url', content: "https://ewns.in"});
    this.metaService.addTag({name: 'og:description', content: aboutDescription});
    this.metaService.addTag({name: 'og:image', content: 'https://ewnsassets.s3.ap-south-1.amazonaws.com/cms/assets/img/favicon-big.png'})
  }

}
